// src/i18n.js
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh-Hant.json'
import ja from './locales/ja.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'

// 定义语言包
const messages = {
  en,
  zh,
  ja,
  fr,
  de,
  es
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 启用Composition API模式
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
